// src/i18n/index.js – lazy-loaded locales; only default language in bundle
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Default locale in bundle for first paint; others loaded on demand
import enLocale from './locales/en.js';

const DEFAULT_LANG = 'en';
const FALLBACK_LANG = 'en';

/** Supported language codes (must match locale filenames and URL :lang). */
export const SUPPORTED_LANGS = ['en', 'de', 'fr', 'es', 'tr', 'ru'];

export function isSupportedLang(lang) {
  return typeof lang === 'string' && SUPPORTED_LANGS.includes(lang.toLowerCase());
}

/**
 * Load a locale dynamically and add it to i18n. Safe to call multiple times for the same lang.
 * @param {string} lang - Language code (e.g. 'de', 'fr')
 * @returns {Promise<void>}
 */
export async function loadLocale(lang) {
  const l = (lang || '').toLowerCase();
  if (!isSupportedLang(l)) return;
  if (i18n.hasResourceBundle(l, 'translation')) return;

  try {
    const mod = await import(
      /* @vite-info: dynamic import for code-splitting */
      `./locales/${l}.js`
    );
    const data = mod.default;
    if (data?.translation) {
      i18n.addResourceBundle(l, 'translation', data.translation, true, true);
    }
  } catch (err) {
    console.warn(`[i18n] Failed to load locale: ${l}`, err);
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources: { [DEFAULT_LANG]: enLocale },
    lng: DEFAULT_LANG,
    fallbackLng: FALLBACK_LANG,
    supportedLngs: SUPPORTED_LANGS,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    defaultNS: 'translation',
    ns: ['translation'],
  });

export default i18n;
